<div class="container">
  <div class="spinner"></div>
  <p>Autenticando, por favor aguarde...</p>
</div>
